<div class="container text-light">
    <div class="modal-header">
        <h4 class="modal-title">Feedback:</h4>
        <button type="button" class="close text-light" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <form>
            <p>Please select finding:</p>
            <div *ngFor="let finding of findings" class="form-check">
                <input class="form-check-input" type="radio" name="findingsInput" id="finding" value="finding">
                <label class="form-check-label" for="finding">
                    {{finding.replace(' score','')}}
                </label>
            </div>

            <div class="form-group notes">
                <label for="comment">Notes:</label>
                <textarea class="form-control notesTextarea text-light" rows="5" id="notes" placeholder="Please insert your notes here..."></textarea>
            </div>

            <button class="btn btn-outline-light buttonStyle">Submit</button>
            <button class="btn btn-outline-light buttonStyle">Close</button>
        </form>

    </div>
    <!--<div class="modal-footer">
        <button type="button" class="btn btn-outline-light" (click)="activeModal.close('Close click')">Close</button>
    </div>-->
</div>